import {DialogBox, DialogBoxBody, DialogBoxProps} from "common/DialogBox"
import {LoraDevice as LoraDeviceDto} from "dto/loradevice/lora-device"
import {useFindAllLoraDevice} from "hooks/queries/lora-device.query"
import {useState} from "react"
import {Pagination} from "common/Pagination"
import {
    GridTableColumn,
    GridTableHeaderWrapper,
    GridTableListItemWrapper
} from "pages/admin/common/common-style-component"
import dayjs from "dayjs"

interface LoraDeviceListProps extends DialogBoxProps {
    handleComplete: (eui: string) => void
}

const TableColumnWidth = "20% 15% 23% auto 10%"

function getSampleLoraDevice(handleComplete: (eui: string) => void) {
    return <LoraDevice device={{
        devEUI: "1234567890123456",
        description: "sdfd",
        name: "sdf",
        lastSeenAt: new Date(),
        deviceProfileId: "123",
        applicationID: "123",
        deviceProfileName: "123",
        deviceStatusBattery: 12,
        deviceStatusBatteryLevel: 12,
        deviceStatusBatteryLevelUnavailable: false,
        deviceStatusExternalPowerSource: false,
        deviceStatusMargin: 12,

    }} key={13423423} handleComplete={handleComplete}/>
}

export const LoraDeviceList = ({show, close, handleComplete}: LoraDeviceListProps) => {
    const [page, setPage] = useState<number>(0)
    const [pageSize] = useState<number>(10)
    const [search, setSearch] = useState("")
    const {data} = useFindAllLoraDevice(page, pageSize, search)
    const {totalCount, result: list} = data?.body || {totalCount: 0, result: []}
    // console.log("lora device data : ", data?.body)
    return (
        <DialogBox show={show} close={close} title="로라 디바이스 선택하기">
            <DialogBoxBody>
                <div>
                    <div className="level ">
                        <div className="level-left">
                            <h5 className="is-size-3 has-text-weight-bold">디바이스 목록</h5>
                        </div>
                        <div className="level-right">
                            <div className="level-item input-search-box5">
                                <div className="btn-search">
                                    <i className="fa fa-search has-text-info"/>
                                </div>
                                <input className="input" type="text" placeholder="디바이스 검색"
                                       value={search} onChange={e => setSearch(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                    <GridTableHeaderWrapper gridTemplateColumns={TableColumnWidth}>
                        <GridTableColumn>장비명</GridTableColumn>
                        <GridTableColumn>EUI</GridTableColumn>
                        <GridTableColumn>통신날짜</GridTableColumn>
                        <GridTableColumn>설명</GridTableColumn>
                        <GridTableColumn>선택</GridTableColumn>
                    </GridTableHeaderWrapper>
                    {list && (
                        list?.map((device: LoraDeviceDto) => {
                            return (
                                <LoraDevice device={device} key={device.devEUI} handleComplete={handleComplete}/>
                            )
                        })
                    )}
                    <Pagination changePage={(page: number) => {
                        setPage(page - 1)
                    }} total={totalCount} size={pageSize} page={page + 1}/>

                    {/*</div>*/}
                </div>
            </DialogBoxBody>
        </DialogBox>
    )
}

const LoraDevice = ({device, handleComplete}: { device: LoraDeviceDto, handleComplete: (eui: string) => void }) => {
    const communicationTime = device.lastSeenAt ? dayjs(device.lastSeenAt).format("YYYY-MM-DD") : "-"
    return (
        <GridTableListItemWrapper gridTemplateColumns={TableColumnWidth}>
            <GridTableColumn>{device.name}</GridTableColumn>
            <GridTableColumn><span
                className="tag is-light is-medium is-warning">{device.devEUI}</span></GridTableColumn>
            <GridTableColumn>{communicationTime}</GridTableColumn>
            <GridTableColumn>{device.description}</GridTableColumn>
            <GridTableColumn>
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a className="button is-info is-size-85 is-rounded mt10"
                   onClick={() => handleComplete(device.devEUI)}>선택</a>
            </GridTableColumn>
        </GridTableListItemWrapper>
    )
}